<template>
  <div>
    <b-progress :height="height" :max="max" :variant="variant" class="mc-progress-bar">
      <b-progress-bar :value="value" class="mc-progress-bar progress-bar">
        <span v-if="labelPosition == 'outside'" :style="labelOutside">
          {{ value + ' %' }}
        </span>
        <span v-else-if="labelPosition == 'inside'">{{ value + ' %' }}</span>
      </b-progress-bar>
    </b-progress>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Number,
    },
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
    variant: {
      type: String,
      default: 'primary',
    },
    labelPosition: {
      //outside or inside
      type: String,
    },
    height: {
      type: String,
      default: '15px',
    },
  },
  computed: {
    labelOutside() {
      const mapNumber = (number, inMin, inMax, outMin, outMax) => {
        const normalizedNumber = (number - inMin) / (inMax - inMin)
        const mappedNumber = normalizedNumber * (outMax - outMin) + outMin
        return Math.min(Math.max(mappedNumber, outMin), outMax)
      }
      let val = mapNumber(this.value, this.min, this.max, 0, 100)
      const textPosition = val > 92 ? '95%' : `${val + 2}%`
      const textColor = val > 97 ? '#ffffff' : '#0D4491'
      return {
        position: 'absolute',
        left: textPosition,
        color: textColor,
      }
    },
  },
  methods: {
    mapNumber(number, inMin, inMax, outMin, outMax) {
      // First, normalize the input number within the input range
      const normalizedNumber = (number - inMin) / (inMax - inMin)

      // Then, scale the normalized number to the output range
      const mappedNumber = normalizedNumber * (outMax - outMin) + outMin

      // Ensure the result stays within the output range
      return Math.min(Math.max(mappedNumber, outMin), outMax)
    },
  },
}
</script>
<style lang="scss" scoped>
.mc-progress-bar {
  font-size: 10px;
  border-radius: 8px;
  background-color: #ebecef;
  .progress-bar {
    border-radius: inherit;
  }
  //   .label-outside {
  //     position: absolute;
  //     left: 55%;
  //     transform: translateX(-50%);
  //     color: $primary;
  //   }
}
</style>
